<template>
  <div>
    <el-dialog title="修改标签"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :append-to-body="true"
               width="500rem"
               :before-close="handleClose">
      <el-row :gutter="10">
        <el-col :span="24"
                class="center_col">
          <span>标签:</span>
          <el-input clearable
                    placeholder="请输入"
                    type="textarea"
                    v-model="form.tags"
                    style="width:85%"
                    :rows="4" />
        </el-col>
      </el-row>
      <div class="btn_warp">
        <div @click="handleClose">
          取消
        </div>
        <div @click="save">
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { editError } from '@/api/errorbasis.js'
export default {
  data () {
    return {
      form: {},
      dialogVisible: false,
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    async save () {
      await editError(this.form)
      this.handleClose()
      this.$message.success('修改成功')
      this.$parent.refresh()
    }
  }
}
</script>

<style lang="scss" scoped>
.center_col {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin-right: 10rem;
    font-size: 18rem;
    font-weight: bold;
  }
}
.el-row {
  &:nth-child(1) {
    display: flex;
    justify-content: center;
    margin-bottom: 10rem;
  }
}

::v-deep .el-dialog__header {
  font-size: 20rem;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4rem;
}

::v-deep .el-dialog__close {
  display: none;
}

.btn_warp {
  height: 50rem;
  border-top: 1rem solid #e5e5e5;
  display: flex;
  width: 554rem;
  margin-left: -20rem;
  position: absolute;
  bottom: 0;
  width: 100%;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &:nth-child(1) {
      font-size: 18rem;
      font-weight: bold;
      color: #999999;
      border-right: 1rem solid #e5e5e5;
    }
    &:nth-child(2) {
      font-size: 18rem;
      font-weight: bold;
      color: #2196f3;
    }
  }
}

::v-deep .el-dialog {
  border-radius: 20rem;
  height: 300rem;
  margin-top: 198rem !important;
}
</style>